import _ from 'es-toolkit/compat';
import { FieldMetaState } from 'react-final-form';

export function hasFieldError(
  meta: FieldMetaState<any> = {},
  showErrorOnlyTouched = true,
): boolean {
  const { submitError, modified, error, touched } = meta;
  const hasAnyError = Boolean(error) && !_.isEmpty(error);
  const hasSubmitError = Boolean(submitError);
  const showError = showErrorOnlyTouched ? !!touched : true;

  return (hasAnyError || hasSubmitError) && showError && !!modified;
}

export function getFieldError(
  meta: FieldMetaState<any> = {},
  showErrorOnlyTouched = true,
): string | null {
  if (hasFieldError(meta, showErrorOnlyTouched)) {
    const { submitError, error } = meta;
    const errorToShow = error || submitError;

    if (typeof errorToShow === 'object') {
      const arrayOfErrors: Array<any> = _.values(errorToShow);
      return arrayOfErrors.join(' ');
    }

    if (Array.isArray(errorToShow)) {
      return errorToShow.join(' ');
    }

    return errorToShow || null;
  }

  return null;
}

export function getFieldWarning(
  value: any,
  meta: FieldMetaState<any> = {},
  warning?: string,
  disabled?: boolean,
): string | null {
  const { error } = meta;

  if (value?.length > 0 || error || disabled || !warning) return null;

  return warning;
}
